import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const OnSubmitContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    display: flex;
    border-radius: 6px;
`;

export const SubmitTick = styled.div`
    width: 71px;
    background: #14853d 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 6px 0px 0px 6px;
    display: grid;
    align-items: center;
    justify-content: center;
    ${media.mobileDevice`
        width: 56px;
        margin: 0px 5px 0px 5px;
    `}
`;

export const SubmitComplete = styled.div`
    color: #202124;
    font-family: 'AvenirNextWorld Demi';
    font-size: 17px;
    text-align: left;
    margin-left: 24px;
    /* margin-top: 10px; */
    ${media.mobileDevice`
        margin-left: 12px;
        line-height: 1.4;
    `}
`;

export const SubmitNumber = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    text-align: left;
    color: #202124;
    margin-left: 24px;
    ${media.mobileDevice`
        margin-left: 12px;
    `}
`;

export const TerritoryDiv = styled.div`
    ${media.mobileDevice`
        margin-top: 23px;
    `}
`;

export const AccountGridContainer = styled(Grid)`
    width: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 6px;
    opacity: 1;
    margin-left: -10px;
    &.AccountSection {
        ${media.mobileDevice`
            padding-left: 10px;
        `}
    }
`;

export const AccountGrid = styled(Grid)`
    &.AccountDetails {
        padding-left: 10px;
        ${media.mobileDevice`
            padding-left: 0;
        `}
    }
`;

export const AccountDetails = styled.div`
    display: ${({ display }) => (display ? 'flex' : '')};
    text-align: left;
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    color: #202124;
    ${media.mobileDevice`
        display: ${({ isInline }) => (isInline && 'inline')};
    `}
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    font-size: 12px;
    letter-spacing: -0.12px;
    align-self: center;
`;

export const GridContainer = styled(Grid)`
    padding: 10px 15px;
    background: #ffffff 0% 0% no-repeat padding-box;
    &:nth-child(even) {
        background: #f3f3f3 0% 0% no-repeat padding-box;
    }
    :first-child {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
    }
    :last-child {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
    }
`;

export const ItemCardTextContainer = styled(Grid)``;

export const SetsHeader = styled.div`
    font-size: 20px;
    margin-top: 10px;
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
`;

export const DesktopSetsList = styled.div`
    box-shadow: 0px 3px 2px #00000029;
    border: 1px solid #DCDCDC;
    border-radius: 6px;
    ${media.mobileDevice`
        display: none;
    `}
`;

export const MobileSetsList = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
        box-shadow: 0px 3px 2px #00000029;
        border: 1px solid #DCDCDC;
        border-radius: 6px;
    `}
`;
export const BatchNumDiv = styled.div`
    width: 100%;
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.1px;
    color: #140f4b;
`;

export const BatchNum = styled.span`
    width: 100%;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
`;

export const SetDesc = styled.div`
    width: 100%;
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 0.7;
`;

export const SetNum = styled.div`
    width: 100%;
    font-size: 15px;
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
`;

export const BarCode = styled.span`
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    color: #140f4b;
`;